<template>
  <div class="wrapper box  box_v">
    <!--头部-->
    <page-head title="电子营业执照查询" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn">
    </page-head>

    <div class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
        <div class="box">
          <div class="box_f1">
            <i-form ref="formInline" inline label-position="top">
              <row :gutter="80">
                <i-col span="8">
                  <FormItem label="法人身份证号" prop="idCardNO">
                    <Input v-model="idCardNO" placeholder="请输入身份证号" clearable @on-enter="initFangyiList" @on-clear="initFangyiList"/>
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="统一社会编码" prop="idCardNO">
                    <Input v-model="uniscid" placeholder="请输入身份证号" clearable @on-enter="initFangyiList" @on-clear="initFangyiList"/>
                  </FormItem>
                </i-col>
              </row>
            </i-form>
          </div>
        </div>
      </Card>
      <Card dis-hover :padding="0" class="box_f1" style="margin-top: 20px">
        <div class="table-card">
          <!-- <div>
            <Button class="bkcc-btn del-btn" @click="delFangyi">删除</Button>
            <Button class="bkcc-btn del-btn" @click="addFangyi">新增</Button>
            <Button class="bkcc-btn del-btn" @click="checkPeople('',1)">审核通过</Button>
          </div> -->
          <div class="bottomtable">
            <i-table
              :columns="settingColumn"
              :border="true"
              :loading="isLoading"
              :data="fangyiList"
              stripe
              ref="table"
              height="500"
            >
              <template slot-scope="{ row, index }" slot="action"> </template>
            </i-table>
          </div>
          <page :total="total" @on-change="pageChange" class="page" :page-size="rows" :current="page" show-total/>
        </div>
      </Card>
    </div>
    <!--导入-->
    <!-- <Modal title="审核不通过" v-model="showShenheModal" @on-cancel="cancelModal" @on-ok="checkPeople('',0)">
      <Form label-position="top">
        <FormItem label="审核不通过原因" prop="checkMsg">
          <Input v-model="checkMsg" placeholder="请输入原因" type="textarea" rows='5'/>
        </FormItem>
      </Form>
    </Modal>
    <Modal title="确认" v-model="delModal" @on-cancel="cancelModal" @on-ok="delFangyiItem">
      <div>确认删除记录吗？删除后将无法恢复</div>
    </Modal> -->
    
  </div>
</template>

<script>
  import pageHead from '../../../components/head'
  import selectCommunity from '../../../components/selectCommunity'
  var that
  export default {
    name: 'domicile',
    components: {
      pageHead,
      selectCommunity
    },
    data() {
      return {
        page: 1,
        rows: 10,
        zoneId: '',
        uniscid: '',
        zoneList: [],
        isLoadZoneList: false,
        roundlist:[],
        qyList:[],
        userName:"",
        idCardNO:"",
        phoneNO:"",
        address:"",
        roundNO:"",
        companyId:"",
        companyName:"",
        appointmentStatus:'',
        //1--待审核,2--审核未通过,3--待领取,4--已领取,5--取消领取
        statusList: [{
          label: '待审核',
          key: 1,
        },
          {
            label: '审核未通过',
            key: 2,
          },
          {
            label: '待领取',
            key: 3,
          }, {
            label: '已领取',
            key: 4,
          }, {
            label: '取消领取',
            key: 5,
          }],
        areadata: [],//行政区域
        fangyiList: [],
        btnList: [
          {
            name: '搜索',
            type: 'search',
            loading: false,
          }, {
            name: '重置',
            type: 'init',
            loading: false,
            btnType: 'default',
          }, {
            name: '设置',
            type: 'set',
            loading: false,
          // }
          },{
          // , {
            name: '导出',
            type: 'export',
            loading: false,
            btnType: 'default',
          }
        ],
        settingColumn: [
          {
            type: 'selection',
            width: 70,
            align: 'center',
            fixed: 'left'
          },
          {
            title: "户号",
            width: '95',
            resizable: true,
            key: "userName",
            fixed: 'left'
          },
          {
            title: "法定代表人",
            width: '95',
            resizable: true,
            key: "name",
            fixed: 'left'
          },
          {
            title: "统一社会信用代码",
            key: 'uniscid',
            resizable: true,
            width:'200',
          },
          {
            title: "住所",
            key: "dom",
            resizable: true,
            width:'230',
          }, {
            title: "企业名称",
            key: "entname",
            resizable: true,
            width:'150',
          }, 
          {
            title: '经营(驻在)期限至',
            key: 'opto',
            resizable: true,
            width:'150',
          },
          {
            title: "电子营业执照执照序列号",
            key: "licencesn",
            resizable: true,
            width:'150'
          },
          {
            title: "经营(驻在)期限自",
            key: "opfirom",
            resizable: true
          },
          //1--待审核,2--审核未通过,3--待领取,4--已领取,5--取消领取
          {
            title: "操作",
            width: 240,
            fixed: 'right',
            render: function (h, params) {
              return h("div",
                [
                  // h(
                  //   "span",
                  //   {
                  //     style: {
                  //       color: "#5e6d94",
                  //     },
                  //     on: {
                  //       click: (e) => {
                  //         e.stopPropagation()
                  //         that.getDetail(params.index)
                  //       }
                  //     }
                  //   },
                  //   "[详情]"
                  // ),
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                        marginLeft: "10px",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.delItem(params.index)
                        }
                      }
                    },
                    "[查看电子证照]"
                  ),
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                        marginLeft: "10px",
                        display:that.fangyiList[params.index].appointmentStatus==1?'':'none'
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.checkPeople(that.fangyiList[params.index].id,1)
                        }
                      }
                    },
                    "[审核通过]"
                  ),
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                        marginLeft: "10px",
                        display:that.fangyiList[params.index].appointmentStatus==1?'':'none'
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.openShenhe()
                          that.checkPeopleId = that.fangyiList[params.index].id
                        }
                      }
                    },
                    "[不通过]"
                  ),
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                        marginLeft: "10px",
                        display:that.fangyiList[params.index].appointmentStatus==3?'':'none'
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.exportPeopleCard(that.fangyiList[params.index].consumeQrcodeUrl,that.fangyiList[params.index].userName)
                        }
                      }
                    },
                    "[下载凭证]"
                  ),
                ]);
            }
          }],
        total: 0,
        isTableLoading: false,
        selectAppointment: [],
        communityId: 0,
        isPermanent: '',
        showShenheModal:false,
        modalTitle:'',
        checkMsg:'',
        delId:'',
        delModal:false,
        //级联行政区域
        communityIdList:[],
        sel_Community:[],
        checkPeopleId:'',//审核不通过用
      }
    },
    computed: {
      isJiedao() {
        return parseInt(this.$store.state.isJiedao);
      }
    },
    watch: {
      communityId(newVal) {
        //点击重置的时候 communityId变为0，此时不应获取当前社区下的微社区
        //watch 只针对当前为街道，才会发生communityId变化
        if (newVal != 0) {
          this.getZoneList(newVal)
        } 
        // else {
        //   this.zoneList = [];
        //   this.zoneId = ''
        // }
      },
      '$route' (to, from) {
        if(from.name == "addRecord")  this.getFangyiList()
      }
    },
    methods: {
      //获取行政区域
      getArea(item, callback) {
        item.loading = true;
        this.$post(this.urlobj.getArea + 'id=' + item.id).then(res => {
          let data = res.map(_item => {
            let resturn_data = {
              pid: _item.pid,
              id: _item.id,
              value: _item.text,
              label: _item.text,
              level: item.level + 1,
            }
            if (item.level != 2) {
              resturn_data.children = []
              resturn_data.loading = false
            }

            return resturn_data
          })
          if (item.level == 0) {
            this.areadata = data
          } else {
            item.loading = false;
            item.children = data
            callback()

          }

        }).catch(e => {
          this.$Message.error('获取行政区域失败')
        })
      },

      communityChange(value){
        if(value){
          this.communityId = value.communityId
          this.communityIdList = value.childrenIdList
        }else{
          this.communityId = ""
          this.communityIdList = []
          this.zoneId = ''
          this.zoneName = ''
        }
        
        this.initFangyiList()
      },
      initFangyiList() {
        this.page = 1
        this.getFangyiList()
      },
      getFangyiList() {
        let {idCardNO,uniscid} = this
        let data = {
          CertNo: idCardNO,
          Uniscid: uniscid,
          Rettype: '3',
          UseFor: '水电气暖报装'
        }

        this.$get(this.urlobj.hujian, data).then(res => {
          // this.total = res.total
          let data = []
          data.push(res)
          this.fangyiList = data
        })
      },
      export() {
        let {userName, idCardNO,phoneNO, address, roundNO,companyId, appointmentStatus, communityIdList,zoneId} = this
        if(!zoneId) zoneId = ""

        if(userName === undefined) userName = ""
        if(idCardNO === undefined) idCardNO = ""
        if(phoneNO === undefined) phoneNO = ""
        if(address === undefined) address = ""
        if(roundNO === undefined) roundNO = ""
        if(companyId === undefined) companyId = ""
        if(appointmentStatus === undefined) appointmentStatus = ""
        if(communityIdList === undefined) communityIdList = []

        let url = this.urlobj.exportYuyueRecord + '?communityIdList=' + communityIdList + '&zoneId=' + zoneId
            + '&userName=' + userName + '&phoneNO=' + phoneNO + '&idCardNO=' + idCardNO
            + '&address=' + address + '&roundNO=' + roundNO+ '&companyId=' + companyId
            + '&appointmentStatus=' + appointmentStatus + '&token=' + this.$store.state.access_token 
        window.open(url)
      },
      handleBtn(type) {
        if (type == 'export') {
          this.export()
        } else if (type == 'search') {
          this.initFangyiList()
        } else if (type == 'set') {
          this.$router.push({name: 'yuyueSetting'})
        } else if (type == 'init') {
          this.userName = ""
          this.idCardNO = ""
          this.phoneNO = ""
          this.address = ""
          this.roundNO = ""
          this.companyName = ""
          this.appointmentStatus = ""
          //行政区域
          this.communityId = 0
          this.communityIdList = []
          this.$store.state.isJiedao && (this.$refs.community.selectCommunity="");
          //小区
          this.zoneId = ''
          this.zoneList = [];
          this.initFangyiList()
        }
      },
      getDetail(index) {
        this.$router.push({
          name: 'fangyidetail',
          query: {id: this.fangyiList[index].id, communityId: this.fangyiList[index].communityId}
        })
      },
      delItem(index) {
        console.log('index',index)
        window.open(this.fangyiList[index].fileUrl)
        console.log('index',this.fangyiList)
        console.log('index',this.fangyiList[index])
        //this.delFangyiItem(this.fangyiList[index].id)
      },
      addFangyi() {
        this.$router.push({name: 'addRecord'})
      },
      delFangyi() {
        var id = this.selectAppointment.map(item => item.id).join(',')
        if (!id) {
          this.$Message.warning('请选择要操作的记录')
          return
        }
        this.delModal = true
        this.delId = id
        //this.delFangyiItem(id)
      },
      delFangyiItem() {
        var url = this.urlobj.delRecordList + '?idList=' + this.delId
        this.$delete(url).then(res => {
          this.$Message.success('删除成功')
          this.initFangyiList()
        })
      },
      cancelModal(){

      },
      pageChange(val) {
        this.page = val;
        this.getFangyiList();
      },
      selectTableItem(value) {
        this.selectAppointment = value
      },
      clickRow(value) {
        this.$router.push({
          name: 'fangyidetail',
          query: {
            id: value.id,
            communityId: value.communityId
          }
        })
      },
      getStatus(checkStatus){
        ////1--待审核,2--审核未通过,3--待领取,4--已领取,5--取消领取
        let obj = {
          label:'',
          color:'',
        }
        switch (checkStatus){
          case 3:
            obj = {
              label:'',
              color:'#00c066',
            }
            break;
          case 4:
          case 5:
            obj = {
              label:'',
              color:'#999999',
            }
            break;
          case 1:
            obj = {
              label:'',
              color:'#eb7b29',
            }
            break;
          case 2:
            obj = {
              label:'',
              color:'#fb4343',
            }
            break;

        }
        return obj

      },
      openShenhe(){
          this.showShenheModal = true
      },
      //审核居民信息
      checkPeople(val,checkStatus,isMust) {
        var ids = val ? val : this.selectAppointment.map(item => item.id).join(',')
        if(!checkStatus) ids=this.checkPeopleId
        if (!ids) {
          this.$Message.warning('请选择要审核的记录')
          return
        }
        let data = {
          ids,
          checkStatus,
          checkMsg:this.checkMsg,
        }
        if(isMust==1) data.isMust = 1
        this.$post(this.urlobj.checkRecordPeople, data).then(res => {
            this.getFangyiList()
        }).catch(e => {
        })
      },
      //下载购买凭证
      exportPeopleCard(url,username) {

        window.open(this.urlobj.downloadAttachment + '?picPath=' + url + '&picName='+username
         + '&token=' + this.$store.state.access_token)
      },
      //复选框回写
      //复选框回写成数据
      getArrayText(val) {
        let arr = this.getIndexAry(val)
        let arr_text = this.symptomSelfList.filter(item => arr.indexOf(item.key) > -1)
        return arr_text.length ? arr_text.map(item => item.label).join(',') : ''
      },
      // 对复选框数值分解
      getIndexAry(num) {
        let arr = Number(num)
          .toString(2)
          .split("");
        let len = arr.length - 1;

        let res = arr.map((item, index) => {
          if (+item) return +item * 2 ** (len - index);
        });

        if (arr.length == 1 && arr[0] == 0) return [0]
        else return res ? res : [];
      },
      //获取微社区列表
      getZoneList(id) {
        this.isLoadZoneList = true
        let url = this.urlobj.zoneList
        this.$get(url, {
          communityId: id,
          zoneType:1,
          hasChild:1
        }).then(res => {
          this.isLoadZoneList = false
          this.zoneList = res.rows
          this.zoneList.push({
            zoneId:0,
            zoneName:'其他'
          })
        }).catch(e => {
          this.isLoadZoneList = false;
          console.log(e)
        })
      },
      //点击选择微社区列表时
      selectZone(val) {
        if (val) {
          //下拉框展开，且communityId为空
          if (!this.communityId) {
            this.$Message.info('请先选择社区')
          } else if (this.isLoadZoneList) {
            this.$Message.info('查询中,请稍后')
          }
        }
      },
      statusChange(value){
        this.appointmentStatus = value?value:""
        this.initFangyiList()
      },
      getRoundList(){
        this.$post(this.urlobj.getYuyueSettingList,{}).then(res=>{
            this.roundlist = res.rows.map(item=>{
                return{
                    id:item.id,
                    label:'第'+this.$util.number2Chinese(item.roundNO)+'轮',
                }
            }).reverse()
        }).catch(e=>{
            
        })
      },
      handleSearchQy(value){
        var url = this.urlobj.getYuyueCompany;
        var data = {
          pageNum: 0,
          pageSize: 0,
          companyName:value,
        };
        this.$get(url, data).then(res => {

            this.qyList =  res.rows.map(item=>{
                return {
                    companyId:item.companyId,
                    companyName:item.companyName,
            
                }
            })
            
            this.isLoading = false
        }).catch(e => {
            this.isLoading = false
            console.log(e)
        });
      },
      selectQy(item){
        this.companyId = item.companyId
        this.initFangyiList()
      }
    },
    created() {},
    mounted() {
      that = this
      //获取预约轮次列表
      this.getRoundList()
      //获取预约记录列表
      this.getFangyiList()
      if (!parseInt(this.$store.state.isJiedao)) {
        //获取小区列表
        this.getZoneList(this.$store.state.streetorcommunityid)
      }
    }
  }
</script>

<style scoped lang="less">
  /deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }

  /deep/ .ivu-date-picker {
    display: block;
  }

  /deep/ .ivu-card-body {
    height: 100%;
  }

  /deep/ .ivu-table-tip {
    overflow-x: hidden;
  }

  .wrapper {
    height: 100%;
  }

  .add-btn {
    min-width: 60px;
    height: 28px;
    line-height: 13px;
    display: block;
  }

  .del-btn {
    margin-bottom: 20px;
  }

  .tab-wrapper {
    position: absolute;
    left: 20px;
    .tab-btn {
      height: 30px;
      line-height: 30px;
      width: 85px;
      text-align: center;
      background: #fff;
      color: #999;
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    .active {
      background: #ff7b44;
      color: #fff
    }
  }

  .nodata-card {
    margin: 0 20px 20px;
    align-items: center;
    justify-content: center;
    img {
      height: 280px;
      width: 390px;
    }
    .text {
      font-size: 15px;
      color: #ff7744;
      line-height: 1;
      padding: 25px 0 30px;
      letter-spacing: 10px;
      text-align: center;
    }
  }

  .card-box {
    margin: 0 20px 20px;
  }

  .table-card {
    padding: 20px 20px 80px;
    position: relative;
    height: 100%;
    text-align: right;
  }

  .page {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }

  .qrCodeUrl-wrapper {
    width: 200px;
    margin: 0 50px;
  }

  .qrCodeUrl {
    display: block;
    height: 200px;
    width: 100%;
    margin-bottom: 30px;
  }

  .qrcode-btn {
    background: #ff7b43;
    color: #fff;
    width: 150px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin: auto;
  }

  .note {
    font-size: 16px !important;
    margin-bottom: 20px;
    .download {
      color: #ff7b44;
      text-decoration: underline;
      margin-left: 5px;
    }
  }
</style>
